const MODE = String(process.env.NODE_ENV) || "development";

export namespace AckLogger {
  export const info = (...data: any[]) => {
    if (shouldLog()) console.log(data);
  };
  export const warn = (...data: any[]) => {
    console.warn(data);
  };
  export const error = (...data: any[]) => {
    console.error(data);
  };

  const shouldLog = (): boolean => {
    return MODE != "production";
  };
}

export default AckLogger;
